/**
 * 标签钩子
 */
import { List } from "@/components/popoverSelect/limit";
import { onMounted, ref, Ref } from "vue";
import { useRoute } from "vue-router";

export interface UseTabs {
  hideTabs: Ref<List[]>;
  setTabs: (id?: string) => void;
  retainName: (id: string) => void;
}

export default function (lists: List[], el: Ref): UseTabs {
  const route = useRoute();
  // 不显示
  const hideTabs = ref([] as List[]);
  const oldId = ref(route.params.id);

  onMounted(() => {
    setTabs();
  });

  /** 获取可展示的数量 */
  const getNumber = () => {
    if (el.value) {
      const children = el.value.children;
      const offsetTop = children?.[0]?.offsetTop;
      const len = Object.keys(children).filter((key) => children[key].offsetTop == offsetTop).length;
      return len;
    }
    return 0;
  };

  /** 设置的tabs */
  const setTabs = (id?: string) => {
    if (id) {
      const n = lists.findIndex((item) => item.code == id);
      if (n) {
        const o: List = lists.splice(n, 1)[0];
        lists.unshift(o);
      }
    }

    const len: number = getNumber();
    hideTabs.value = lists.slice(len);
  };

  /** 保持name页 */
  const retainName = (id: string) => {
    const oldO = lists.find((item: List) => item.code == oldId.value);
    if (oldO && route.name) oldO.nowName = String(route.name);
    oldId.value = id;
  };
  return { hideTabs, setTabs, retainName };
}
